import { Flex, Box, Image, HStack, Link } from "@chakra-ui/react";
import React from "react";
import ConnectButton from "../components/ConnectButton";
import { useLocation } from "react-router-dom";
import NetWorth from "../components/NetWorth";

import logo from "../images/logo.png";
import User from "../components/User";

const AppLanding = () => {
  const location = useLocation();
  const data = location.state?.data;

  return (
    <div>
      <Flex
        borderBottom="0.5px solid #292929"
        w="100%"
        pt="15px"
        pl="15px"
        pr="15px"
        pb="0px"
        alignItems="space-between"
        justifyContent="space-between"
      >
        <Link href="/" _hover={{ textDecoration: "none" }}>
          <HStack>
            <Box>
              <Image boxSize="60px" src={logo} />
            </Box>

            <Box
              display={{ base: "none", md: "flex" }}
              fontWeight="600"
              fontSize="17px"
            >
              ChainPulse
            </Box>
          </HStack>
        </Link>

        <HStack>
          <ConnectButton />
          <User address={data} />
        </HStack>
      </Flex>

      <NetWorth info={data} />
    </div>
  );
};

export default AppLanding;
